<script>
import { getQuantitiesInsights } from '../../services/stock.service';

export default {
  name: 'StockInsights',
  props: ['isUserCEO'],
  data() {
    return {
      quantitiesInsights: {
        quantityReceived: 0,
        quantityOnHand: 0,
        quantityAvailable: 0,
        quantityShipped: 0,
        quantityConfirmed: 0,
        totalExpeditions: 0,
        quantityDefective: 0,
        quantityInStock: 0,
        outbound: {
          statusQuantities: [],
        },
      },
    };
  },

  async mounted() {
    this.quantitiesInsights = await getQuantitiesInsights(
      this.$route.params.id,
    );
  },

  methods: {
    startCase: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>

<template>
  <div>
    <div>
      <h1 class="font-bold text-xl ">
        Stock Quantities Insights
      </h1>
      <div
        class="flex gap-4 items-center justify-center flex-wrap mt-4"
        v-if="quantitiesInsights"
      >
        <div v-if="isUserCEO">
          <div class="text-2xl font-bold">
            {{ quantitiesInsights.quantityReceived }}
          </div>
          <div class="font-semibold text-gray-700 tracking-wider">
            Total Units
          </div>
        </div>
        <div>
          <div class="text-2xl font-bold">
            {{ quantitiesInsights.quantityOnHand }}
          </div>
          <div class="font-semibold text-gray-700 tracking-wider">
            On hand
          </div>
        </div>

        <div>
          <div class="text-2xl font-bold ">
            {{ quantitiesInsights.quantityShipped }}
          </div>
          <div class="font-semibold text-gray-700 tracking-wider">
            Out hand
          </div>
        </div>
        <div>
          <div class="text-2xl font-bold">
            {{ quantitiesInsights.quantityAvailable }}
          </div>
          <div class="font-semibold text-gray-700 tracking-wider">
            Available
          </div>
        </div>
        <div>
          <div class="text-2xl font-bold">
            {{ quantitiesInsights.quantityDefective }}
          </div>
          <div class="font-semibold text-gray-700 tracking-wider">
            Defective
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="isUserCEO">
      <h1 class="font-bold text-xl mb-4">
        Quantities by status
      </h1>
      <div class="flex items-center justify-center gap-4 flex-wrap">
        <div class="flex gap-4 mt-3 items-center justify-center flex-wrap">
          <template
            v-for="item in quantitiesInsights.outbound.statusQuantities"
          >
            <div>
              <div class="text-2xl font-bold">
                {{ item.totalQuantity }}
              </div>
              <div class="font-semibold text-gray-700 tracking-wider">
                {{ startCase(item.status) }}
              </div>
            </div>
          </template>
        </div>
        <div class="divider"></div>
        <div class="flex gap-4 mt-3 items-center justify-center flex-wrap">
          <div>
            <div class="text-2xl font-bold">
              {{ quantitiesInsights.quantityConfirmed }}
            </div>
            <div class="font-semibold text-gray-700 tracking-wider">
              Confirmed
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
.divider {
  height: 100px;
  width: 2px;
  background-color: black;
}

@media (max-width: 768px) {
  .divider {
    display: none;
  }
}
</style>
